import React, { useEffect, useState } from "react";
import { Route } from "react-router-dom";
import { scAxiosAdmin } from "../..";
import { API_TOKEN_NAME, IMAGE_URL } from "../../constants";
import { ToastContainer, toast } from "react-toastify";
import LeftSidebar from "../../component/admin/LeftSidebar";
import TopHeader from "../../component/admin/TopHeader";
import Pagination from "react-js-pagination";
import Avatar from "../../images/avatar_circle.png";
import Modal from "./DeleteConfirmModalPopup";

const GetAllStaticPages = () =>
  scAxiosAdmin.request("/static_services_pages", {
    method: "get",
    headers: {
      Accept: "application/json",
      Authorization: "Bearer " + localStorage.getItem(API_TOKEN_NAME),
    },
  });

const deletePackage = (data) =>
  scAxiosAdmin.request(`/static_services_pages/${data.staticpage_id}`, {
    method: "delete",
    headers: {
      Accept: "application/json",
      Authorization: "Bearer " + localStorage.getItem(API_TOKEN_NAME),
    },
    params: { ...data },
  });

const StaticPages = () => {
  const [allStaticPages, setAllStaticPages] = useState([]); // To store all fetched data
  const [staticPages, setStaticPages] = useState([]); // To store filtered/paginated data
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(0);
  const [searchKeywords, setSearchKeywords] = useState("");
  const [modalDeleteConfirm, setModalDeleteConfirm] = useState(false);
  const [staticPageId, setStaticPageId] = useState("");

  const itemsPerPage = 10;

  const refreshStaticPages = () => {
    GetAllStaticPages()
      .then((res) => {
        if (res.data) {
          setAllStaticPages(res.data);
          setStaticPages(res.data.slice(0, itemsPerPage));
          setTotalPages(Math.ceil(res.data.length / itemsPerPage));
        }
      })
      .catch((err) => console.error(err));
  };
  console.log("your log output", totalPages);
  const handleDeleteStaticPage = (id) => {
    deletePackage({ staticpage_id: id })
      .then((res) => {
        if (res.data.status) {
          toast.success(res.data.message, {
            position: toast.POSITION.TOP_RIGHT,
          });
          refreshStaticPages();
        } else {
          toast.error(res.data.message, {
            position: toast.POSITION.BOTTOM_RIGHT,
          });
        }
      })
      .catch((err) => console.error(err));
  };

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
    const startIdx = (pageNumber - 1) * itemsPerPage;
    setStaticPages(allStaticPages.slice(startIdx, startIdx + itemsPerPage));
  };

  const handleSearch = () => {
    const filteredPages = allStaticPages.filter((page) =>
      page.title.toLowerCase().includes(searchKeywords.toLowerCase())
    );
    setStaticPages(filteredPages.slice(0, itemsPerPage));
    setTotalPages(Math.ceil(filteredPages.length / itemsPerPage));
    setCurrentPage(1);
  };

  useEffect(() => {
    refreshStaticPages();
  }, []);

  return (
    <div className="fixed-left">
      <div id="wrapper">
        <Route component={LeftSidebar} />
        <div className="content-page">
          <div className="content">
            <Route component={TopHeader} />
            <div className="page-content-wrapper">
              <div className="container-fluid">
                <div className="row">
                  <div className="col-12">
                    <div className="card m-b-20">
                      <div className="card-body">
                        <div className="row">
                          <div className="col-sm-7">
                            <h4 className="mt-0 header-title">Static Pages</h4>
                          </div>
                          <div className="col-sm-3 text-right">
                            <input
                              type="text"
                              className="form-control"
                              value={searchKeywords}
                              onChange={(e) =>
                                setSearchKeywords(e.target.value)
                              }
                              onKeyUp={handleSearch}
                              placeholder="Search"
                            />
                          </div>
                          <div className="col-sm-2 text-right">
                            <a
                              href="/addstaticpage"
                              className="btn btn-sm btn-primary waves-effect waves-light"
                            >
                              Add Static Page
                            </a>
                          </div>
                        </div>
                        <div className="table-rep-plugin">
                          <div className="table-responsive b-0">
                            <table className="table table-striped">
                              <thead>
                                <tr>
                                  <th>Page ID</th>
                                  <th>Banner Image</th>
                                  <th>Title</th>
                                  <th>Components</th>
                                  <th>Action</th>
                                </tr>
                              </thead>
                              <tbody>
                                {staticPages.length > 0 ? (
                                  staticPages.map((page) => (
                                    <tr key={page.id}>
                                      <td>#{page.id}</td>
                                      <td>
                                        {page.image_mave ? (
                                          <img
                                            src={`${IMAGE_URL}${page.image_mave}`}
                                            alt="banner"
                                            style={{
                                              width: "50px",
                                              height: "50px",
                                              borderRadius: "30px",
                                            }}
                                          />
                                        ) : (
                                          <img
                                            src={Avatar}
                                            alt="avatar"
                                            width="50px"
                                          />
                                        )}
                                      </td>
                                      <td>{page.title}</td>
                                      <td>
                                        {page.components.map((comp, idx) => (
                                          <div key={comp.id}>
                                            {`${idx + 1}. ${comp.type}`}
                                          </div>
                                        ))}
                                      </td>
                                      <td>
                                        <a
                                          href={`/admin/editpage/${page.id}?name=${page.slug}`}
                                        >
                                          <i className="fa fa-pencil-square"></i>
                                        </a>
                                        <a href={`/page/${page.slug}`}>
                                          <i className="fa fa-eye"></i>
                                        </a>
                                        <a
                                          onClick={() => {
                                            setStaticPageId(page.id);
                                            setModalDeleteConfirm(true);
                                          }}
                                        >
                                          <i className="fa fa-trash"></i>
                                        </a>
                                        <Modal
                                          show={modalDeleteConfirm}
                                          handleClose={() =>
                                            setModalDeleteConfirm(false)
                                          }
                                        >
                                          <div className="custom_reviews_popup">
                                            <h2 className="text-center">
                                              Are you sure you wish to delete
                                              this static page?
                                            </h2>
                                            <form
                                              className="pop-form"
                                              id="edit_education"
                                            >
                                              <div className="form-group row">
                                                <div className="col-sm-3 text-center"></div>
                                                <div className="col-sm-6 text-center">
                                                  <button
                                                    type="button"
                                                    className="blue_btn_box add_staff_btn mt-5 mr-2"
                                                    onClick={() =>
                                                      setModalDeleteConfirm(
                                                        false
                                                      )
                                                    }
                                                  >
                                                    No
                                                  </button>
                                                  <button
                                                    type="button"
                                                    className="blue_btn_box add_staff_btn mt-5"
                                                    onClick={() => {
                                                      handleDeleteStaticPage(
                                                        staticPageId
                                                      );
                                                      setModalDeleteConfirm(
                                                        false
                                                      );
                                                    }}
                                                  >
                                                    Yes
                                                  </button>
                                                </div>
                                                <div className="col-sm-3 text-center"></div>
                                              </div>
                                            </form>
                                          </div>
                                        </Modal>
                                      </td>
                                    </tr>
                                  ))
                                ) : (
                                  <tr>
                                    <td colSpan="5" className="text-center">
                                      No Static Pages found.
                                    </td>
                                  </tr>
                                )}
                              </tbody>
                            </table>
                            {totalPages > 1 && (
                              <Pagination
                                activePage={currentPage}
                                totalItemsCount={allStaticPages.length}
                                itemsCountPerPage={itemsPerPage}
                                pageRangeDisplayed={5}
                                onChange={handlePageChange}
                              />
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <ToastContainer autoClose={5000} />
      </div>
    </div>
  );
};

export default StaticPages;



// WEBPACK FOOTER //
// ./src/component/admin/staticpages.js